import { BOOST_CODE } from '@packages/types';

import { Text } from '@elements/text';
import { useTripStore } from '@store';
import { testProps } from '@utils';

export const ExtraCancellationText = () => {
  const tripExtrasExtraCancellationText = useTripStore(state => {
    const extraCancellationBoost = state.trip.boosts.find(
      b => b.code === BOOST_CODE.EXTRA_CANCELLATION && b.isAdded,
    );
    if (!extraCancellationBoost) return null;

    const selectedValue = extraCancellationBoost?.boostProperty.options?.find(
      i => i.value === extraCancellationBoost?.boostProperty?.selectedExtraCover,
    );

    return `${extraCancellationBoost?.name}: ${selectedValue?.description} coverage`;
  });
  if (!tripExtrasExtraCancellationText) return null;
  return (
    <Text {...testProps('policyDetails-extraCancellation')}>{tripExtrasExtraCancellationText}</Text>
  );
};
